import React, { useContext, useState } from "react";
import Card from "../../../components/Cards/Card";
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '../../../components/Utils/Tooltips';
import { Add, Check, Export, More } from '../../../components/Icons/Icons';
import { useHistory } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import moment from "moment";
import ProtocolContext from '../ProtocolContext/ProtocolContext';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Loader from "../../../components/Common/Loader";
import useMoves from "../../Inventory/Hooks/useMoves";
import { MoveStatus, MoveTypes } from "../../../api/Inventory/Entities/InventoryMovementEntities";
import { AssignmentType } from "../../../api/Inventory/Entities/InventoryEntities";
import { WithAuth } from '../../../components/Authorization/WithAuthProtocol';

export function LaboratoryKitTabContainer() {
    const { t } = useTranslation();
    const history = useHistory();
    const protocolContext = useContext(ProtocolContext);
    const [pagedMoves, isLoading, navigation] = useMoves({
        pageSize: 10,
        pageNumber: 1,
        sortColumn: 'createat',
        sortOrder: 'desc',
        includedTypes: `${MoveTypes.LaboratoryKitDispense.Name},${MoveTypes.LaboratoryKitDispenseRequest.Name}`,
        assignmentTypes: AssignmentType.ProtocolLaboratoryKit.Name,
        assignId: protocolContext.protocolId
    });


    function handleTableChange(type, { page, sizePerPage, sortField, sortOrder }) {
        navigation.ToPage({
            page
        })
    }

    function handleDispense() {
        history.push(`/admin/protocols/${protocolContext.protocolId}/laboratorykit/request`)
    }

    function handleDispenseDeliver(dispenseId) {
        history.push(`/admin/protocols/${protocolContext.protocolId}/laboratorykit/${dispenseId}/deliver`)
    }
    function handleShowMoveDetail(dispenseId) {
        history.push(`/admin/protocols/${protocolContext.protocolId}/laboratorykit/${dispenseId}/detail`)
    }

    const columns = [
        {
            dataField: 'user.fullName', text: 'Nombre', headerStyle: { width: '15rem' }
        },
        {
            text: t('commons.date'), headerStyle: { width: '6rem' }
            , formatter: function (_cell, move, rowIndex) {
                return moment(move.createAt).format("DD/MM/YYYY HH:mm");
            }
        },
        {
            dataField: 'status', text: t('commons.state'), headerStyle: { width: '7rem' }
            , formatter: (cell, row) => t(`inventory.movements.moveState.${cell}`)
        },
        {
            dataField: 'view',
            text: "",
            isDummyField: true,
            headerClasses: 'header-actions',
            classes: 'row-actions',
            formatter: function (_cell, row, rowIndex) {
                return (
                    <div key={rowIndex}>
                        {row.status == MoveStatus.Confirmed.Name.toLowerCase() &&
                            <WithAuth protocolId={protocolContext.protocolId} requiredPermission={["LaboratoryKit.Edit"]}>
                                <button className="btn-table-actions" onClick={() => { handleDispenseDeliver(row.id) }}>
                                    <Tooltip tooltip={t('inventory.dispense.deliver')} id={"tooltipedit-" + row.Id}>
                                        <span aria-hidden="true"><Export /></span>
                                    </Tooltip>
                                </button>
                            </WithAuth>
                        }

                        <button className="btn-table-actions" onClick={() => { handleShowMoveDetail(row.id) }}>
                            <Tooltip tooltip={t('commons.viewDetails')} id={"tooltipedit-" + row.Id}>
                                <span aria-hidden="true"><More /></span>
                            </Tooltip>
                        </button>
                    </div>
                )
            }
        }
    ]

    return (<>
        <Card
            header={<div>
                <WithAuth protocolId={protocolContext.protocolId} requiredPermission={["LaboratoryKit.Edit"]}>
                    <button onClick={() => handleDispense(0)} className="btn btn-primary">
                        <Tooltip tooltip={t('inventory.dispense.createRequest')}>
                            <span aria-hidden="true"> {t('inventory.dispense.request')} <Add /></span>
                        </Tooltip>
                    </button>
                </WithAuth>
            </div >}
            content={< Loader isLoading={isLoading} >
                <Row>
                    <Col sm={12}>
                        <BootstrapTable
                            bordered={false}
                            hover
                            remote
                            condensed
                            keyField='id'
                            classes="table-spaced table-spaced-small"
                            wrapperClasses="table-responsive"
                            columns={columns}
                            data={pagedMoves.Values}
                            loading={isLoading}
                            noDataIndication={() => <>{t("commons.noData")}</>}
                            pagination={paginationFactory({
                                page: pagedMoves.PageNumber,
                                sizePerPage: pagedMoves.PageSize,
                                totalSize: pagedMoves.TotalCount,
                                hideSizePerPage: true
                            })}
                            onTableChange={handleTableChange}
                        />
                    </Col>
                </Row>
            </Loader >}
        />
    </>)
}